import eingangsrechnung from './eingangsrechnung';
import werkzeug from './werkzeug';
import messmittel from './messmittel';
import prozesskontrollkarte from './prozesskontrollkarte';
import abmusterung from './abmusterung';
import lagerort from './lagerort';
import dokument from './dokument';
import infra from './infra';
import produktion from './produktion';
import lieferschein from './lieferschein';
import infrastruktur from './infrastruktur';
import standard from './standard';
import wareneingangspruefung from './wareneingangspruefung';

export default {
  eingangsrechnung,
  werkzeug,
  messmittel,
  lagerort,
  dokument,
  prozesskontrollkarte,
  infra,
  abmusterung,
  produktion,
  infrastruktur,
  lieferschein,
  wareneingangspruefung,
  standard,
};
